module.exports = __webpack_public_path__ + "img/n2.16d118db.jpg";